(function($) {

	'use strict';

	var init = function() {

		$('.header__nav__burger').on('click', function() {
			$('.header__nav__burger--bar').toggleClass('active');
			$('.header__nav__menu').toggleClass('active');
			
			/* Bloquer le scroll sur la page quand le menu est ouvert */
			$('html').toggleClass('active');
			isBlocked = !isBlocked;
			if(isBlocked === true) {
				blockScroll();
			} else {
				letScroll();
			}
		});
        
	};

	var isBlocked = false;

	var blockScroll = function() {
		$(document).bind(
			'touchmove',
				function(e) {
				  e.preventDefault();
				});
	}

	var letScroll = function() {
		$(document).unbind('touchmove');
	}

	$(document).ready(function() {
		init();
	});

})(jQuery);
